// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import * as bootstrap from "bootstrap"
import Highcharts from "highcharts"

// Make Bootstrap available globally for inline scripts
window.bootstrap = bootstrap

// Make Highcharts available globally
window.Highcharts = Highcharts
